module.exports = __webpack_public_path__ + "static/media/fail.13107f6a.svg";